module.exports = "https://static.wmbcdn.com/uniweb/images/0cb28e4ff43791800ff9cd2228f6f8f7.svg";